// Helper: parse date input from multiple formats to YYYY-MM-DD
export const parseDateInput = (input) => {
  if (!input) return null;

  const cleaned = input.trim();

  // Already in YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(cleaned)) {
    return isValidDate(cleaned) ? cleaned : null;
  }

  // MM-DD-YYYY format (with dashes or slashes, 4-digit year)
  const mdyFullMatch = cleaned.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/);
  if (mdyFullMatch) {
    let [, month, day, year] = mdyFullMatch;
    // Pad month and day with zeros
    month = month.padStart(2, '0');
    day = day.padStart(2, '0');

    const result = `${year}-${month}-${day}`;
    return isValidDate(result) ? result : null;
  }

  // MM-DD-YY format (with dashes or slashes, 2-digit year)
  const mdyMatch = cleaned.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{2})$/);
  if (mdyMatch) {
    let [, month, day, year] = mdyMatch;
    // Convert 2-digit year to 4-digit (00-29 = 2000s, 30-99 = 1900s)
    const yearNum = parseInt(year);
    const fullYear = yearNum <= 29 ? 2000 + yearNum : 1900 + yearNum;

    // Pad month and day with zeros
    month = month.padStart(2, '0');
    day = day.padStart(2, '0');

    const result = `${fullYear}-${month}-${day}`;
    return isValidDate(result) ? result : null;
  }

  // YYYYMMDD format (8 digits, no separators)
  if (/^\d{8}$/.test(cleaned)) {
    const year = cleaned.substring(0, 4);
    const month = cleaned.substring(4, 6);
    const day = cleaned.substring(6, 8);
    const result = `${year}-${month}-${day}`;
    return isValidDate(result) ? result : null;
  }

  // MMDDYY format (6 digits, no separators)
  if (/^\d{6}$/.test(cleaned)) {
    const month = cleaned.substring(0, 2);
    const day = cleaned.substring(2, 4);
    const year = cleaned.substring(4, 6);
    const yearNum = parseInt(year);
    const fullYear = yearNum <= 29 ? 2000 + yearNum : 1900 + yearNum;
    const result = `${fullYear}-${month}-${day}`;
    return isValidDate(result) ? result : null;
  }

  // Invalid format
  return null;
};

// Helper: validate that date has valid month/day values
export const isValidDate = (dateStr) => {
  if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false;

  const [year, month, day] = dateStr.split('-').map(Number);

  // Basic validation
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;

  // Month-specific validation
  const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Check for leap year
  const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  if (isLeapYear && month === 2) {
    daysInMonth[1] = 29;
  }

  if (day > daysInMonth[month - 1]) return false;

  return true;
};
